module.exports = __webpack_public_path__ + "img/FirsttimerIcon.dfbe7294.jpg";